import angular from 'angular';
import uiRouter from 'angular-ui-router';
import coachEditComponent from './coachEdit.component';

let coachEditModule = angular.module('coachEdit', [
  uiRouter
]).config(($stateProvider) => {
	'ngInject';

	$stateProvider.state('coach-edit', {
		url: '/coaches/edit/:id',
		component: 'coachEdit',
		data: {pageTitle: 'EDIT_COACH'},
		params: {
			id: {squash: true, value: null}
		},
		resolve: {
			hasPermission: ($q, $rootScope, Permissions, $stateParams) => {
				'ngInject';
				let deferred = $q.defer();

				if($rootScope.user.canDo(Permissions.EDIT_COACH)){
					deferred.resolve();
				}else{
					deferred.reject("Access denied!");
				}

				return deferred.promise;
			}
		}
	});
})
.component('coachEdit', coachEditComponent)
.name;

export default coachEditModule;



// WEBPACK FOOTER //
// ./client/app/components/coaches/coachEdit/coachEdit.js